module.exports = __webpack_public_path__ + "static/media/water-lower.90789b74.svg";